export default __webpack_public_path__ + "b18c35b0c4e56329482335ef13dec589.otf";